var _rect, _path, _rect2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckBoxActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 3.5,
    fill: "#CC5803"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.50797 11.6445C7.06836 12.1185 6.35047 12.1185 5.91087 11.6445L3.3297 8.8611C2.8901 8.38706 2.8901 7.61294 3.3297 7.1389C3.76931 6.66485 4.48719 6.66485 4.9268 7.1389L6.70942 9.06116L11.0732 4.35553C11.5128 3.88149 12.2307 3.88149 12.6703 4.35553C13.1099 4.82957 13.1099 5.6037 12.6703 6.07774L7.50797 11.6445Z",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 15,
    height: 15,
    rx: 3.5,
    stroke: "#CC5803"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckBoxActive);
export default __webpack_public_path__ + "static/media/CheckBoxActive.ed126cf02227f887bdb5068ffa84ff71.svg";
export { ForwardRef as ReactComponent };